/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "@blueprintjs/core"
import { __, jsonToData } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"
import updateSection from "../utils/updateSection"
import updateHistory from "../utils/updateHistory"
import { showToast } from "src/libs/useful"
import { useEffect, useState } from "react"


/* 
* Вставляет данные секции из клипборда в список секций после текущей
* Не работает в localhost
* Protopia Ecosystem component 
*/

export interface IClipboardSectionProps {
   section: ILandingSection
}
const ClipboardSection = (props: IClipboardSectionProps): JSX.Element => {
    const currentLanding: ILanding = useLandingConsoleStore((state: ILandingStore) => state.currentLanding)
    const [is, setIs] = useState<boolean>(false)

    const maybeClipboard = async () => {
        try {
            const promise = await navigator.clipboard.readText();
            if(!promise) {
                return
            } 
            const maybeSection: any = jsonToData( promise, undefined, onNoJson )
            if( !!maybeSection?.id && Array.isArray(maybeSection?.data && !!maybeSection?.composition && Array.isArray(maybeSection?.floats))) {
                setIs( true )
            } 
        }
        catch (err: any) {
            console.log( err )
        }
    }
    useEffect( () => {
        maybeClipboard()
    }, [])

    if(!is) {
        return <></>
    }
    const onNoJson = () => {
        showToast({ message: __( 'Clipboard data not section.' ) }) 
    }
    const onpaste = async () => {
        try {
            const text = await navigator.clipboard.readText();
            console.log( text );
            const maybeSection: any = jsonToData( text, undefined, onNoJson )
            if( !!maybeSection?.id && Array.isArray(maybeSection?.data && !!maybeSection?.composition && Array.isArray(maybeSection?.floats))) {
                const order: number = currentLanding.sections.findIndex( s => s.id === props.section.id ) || currentLanding.sections.length - 1
                let newVal: ILanding = JSON.parse(JSON.stringify({ ...currentLanding, }))
                newVal.sections.splice(order, maybeSection)
                updateHistory(
                    {
                        data: newVal,
                        prevData: currentLanding,
                        type: HISTORY_TYPE.FULL,
                        title: "Paste section from clipboard"

                    } as IHistoryStep,
                    newVal
                )
            }
            else {
                showToast({ message: __( 'Clipboard data not section.' ) }) 
            }
        } catch (err: any) {
            if (err.name === 'NotAllowedError') {
                // Пользователь отказал или разрешение отозвано
                showToast({message: __('Доступ к буферу запрещён')}) 
            } else {
                showToast({message: __('Unknown clipboard error')}) 
            }
        }
    }
    return <Button variant="minimal" fill alignText="left" icon="clipboard" onClick={onpaste}>
        <div className="px-2 py-1 letter-spacing-1 smaller">
            Paste section data from clipboard
        </div>
    </Button>
}
export default ClipboardSection